import axios from "../httpService";

class ResearchGroupsService {
  async fetchResearchGroups() {
    try {
      const result = await axios
        .get("/api/blastresearchgroup")
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data };
    }
  }

  async createResearchGroup(data) {
    try {
      const result = await axios
        .post("/api/blastresearchgroup", data)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data };
    }
  }

  async getResearchGroupData(id) {
    try {
      const result = await axios
        .get(`/api/blastresearchgroup/${id}`)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data };
    }
  }

  async updateResearchGroup(id, data) {
    try {
      const result = await axios
        .put(`/api/blastresearchgroup/${id}`, data)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data.response };
    }
  }

  async assignStudentToResearchGroup(id, data) {
    try {
      const result = await axios
        .post(`/api/blastresearchgroup/assign-to-users/${id}`, data)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data.response };
    }
  }

  async getResearchGroupReportByStudents(data) {
    try {
      //for research report request timeout is removed
      axios.defaults.timeout = 0;

      const result = await axios
        .post("/api/blastresearchgroup/generate-report", data)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data.response };
    }
  }

  async getResearchGroupReportForProfessor(data) {
    try {
      axios.defaults.timeout = 0;
      const result = await axios
        .post("/api/blastresearchgroup/generate-report/professor", data)
        .then((res) => res.data);
      return result;
    } catch (ex) {
      return { apierror: ex.response.data.response };
    }
  }
}

export default new ResearchGroupsService();
